// eslint-disable-next-line
import { noticeBannerQueryFilter } from 'utils/proptypes';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';

const { urls, methods, execute } = base();
const getNoticeBannersByFilter = (queryFilter: noticeBannerQueryFilter) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.noticeBanner.noticeBanner}/?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getNoticeBannersByFilterForUser = (queryFilter: noticeBannerQueryFilter) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.noticeBanner.noticeBanner}/for-user/?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getNoticeBanners = () => {
  const method = methods.GET;
  const url = `${urls.noticeBanner.noticeBanner}?limit=10`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getNoticeBannerById = (id: string) => {
  const method = methods.GET;
  const url = `${urls.noticeBanner.noticeBanner}/${id}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const createNoticeBanner = (payload: any) => {
  const method = methods.POST;
  const url = `${urls.noticeBanner.noticeBanner}`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const updateNoticeBannerById = (id: any,payload: any) => {
  const method = methods.PUT;
  const url = `${urls.noticeBanner.noticeBanner}/${id}`;
  const response = execute(method, url, { authorization: true }, payload);
  return response;
};

const updateStatusNoticeBannerById = (payload: { id: any, isActive: boolean }) => {
    const method = methods.PATCH;
    const url = `${urls.noticeBanner.noticeBanner}/${payload.id}`;
    const response = execute(method, url, { authorization: true }, { isActive: payload.isActive });
  
    return response;
};

const deleteNoticeBannerById = (id: string) => {
    const method = methods.DELETE;
    const url = `${urls.noticeBanner.noticeBanner}/${id}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
};

export {
    getNoticeBannersByFilter,
    getNoticeBannersByFilterForUser,
    getNoticeBanners,
    getNoticeBannerById,
    createNoticeBanner,
    updateNoticeBannerById,
    updateStatusNoticeBannerById,
    deleteNoticeBannerById
};
